<template>
  <v-container>
    <h1 class="display-1 pt-3">Classroom Homepage</h1>
    <p>Previously called Course Delivery</p>
    <v-row align="center">
      <v-col cols="12">
        <v-card class="pt-1" outlined="" flat="">
          <v-simple-table fixed-header>
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Homepage Courses</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  dark
                  depressed=""
                  @click="addCourseModal = true"
                  >Add Course</v-btn
                >
              </v-toolbar>
              <v-card flat class="pt-0">
                <v-card-subtitle class="pt-0 pb-1 d-flex">
                  List of enrollment options users have when they go to your
                  <!-- eslint-disable-next-line prettier/prettier -->
                  organization's
                  <a
                    class="ml-1"
                    :href="
                      `https://${$store.getters['getOrganization'].subdomain}.arist.co`
                    "
                    target="__BLANK__"
                  >
                    classroom</a
                  ><v-spacer />
                  <v-switch
                    v-model="showDisabled"
                    class="mb-auto mt-auto"
                    color="blue"
                    label="Show Disabled"
                  >
                  </v-switch>
                </v-card-subtitle>
              </v-card>
            </template>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Actions</th>

                  <th class="text-left">Course Name</th>
                  <th class="text-left shortcol">Price</th>
                  <th class="text-left shortcol">Active Users</th>
                  <th class="text-right longcol">Specials</th>
                </tr>
              </thead>
              <draggable
                class="list-group"
                style="width:100%"
                tag="tbody"
                handle=".handle"
                v-bind="dragOptions"
                v-model="deliverys"
                @end="updateList"
              >
                <tr v-for="item in filterDeliveries(deliverys)" :key="item._id">
                  <a-l-sharemodal
                    :dialog="show === item._id"
                    :name="
                      item && item.course && item.course.name
                        ? item.course.name
                        : 'None'
                    "
                    :id="item._id"
                    :accesscode="item.properties.accessCode"
                    :accesscoderequired="item.properties.requireAccessCode"
                    @finish="show = ''"
                  >
                  </a-l-sharemodal>
                  <td class="actioncol">
                    <div class="d-inline-flex">
                      <!-- <v-tooltip top> -->
                      <!-- <template v-slot:activator="{ on }"> -->
                      <v-icon
                        small
                        class="mr-2 handle d-none d-md-flex"
                        v-if="showDisabled"
                      >
                        mdi-drag-horizontal
                      </v-icon>
                      <!-- </template> -->
                      <!-- <span>Move Order</span> -->
                      <!-- </v-tooltip> -->
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            small
                            class="mr-2 d-none d-md-flex standard-icon"
                            v-on="on"
                            @click="edit(item)"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Edit Delivery Options</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            small
                            v-on="on"
                            class="mr-2 d-none d-md-flex disable-icon"
                            @click="disable(item)"
                          >
                            {{ !isDisabled(item) ? "mdi-cancel" : "mdi-power" }}
                          </v-icon>
                        </template>
                        <span>{{
                          !isDisabled(item) ? "Disable" : "Enable"
                        }}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            small
                            v-on="on"
                            @click="share(item)"
                            class="standard-icon"
                          >
                            mdi-share
                          </v-icon>
                        </template>
                        <span>Share URL {{ item.share }}</span>
                      </v-tooltip>
                    </div>
                  </td>

                  <td class="longcol">
                    {{
                      item && item.course && item.course.name
                        ? item.course.name
                        : "None"
                    }}
                  </td>
                  <td class="shortcol">
                    {{
                      Number(item.logistics.price) == 0
                        ? "Free"
                        : "$" + fixNum(Number(item.logistics.price))
                    }}
                  </td>
                  <td class="shortcol">{{ item.activeUsers }}</td>
                  <td class="chipcol text-right">
                    <v-chip
                      small=""
                      class="ml-2"
                      v-for="special in generateTags(item)"
                      :key="special"
                      :dark="special == 'Disabled'"
                      :color="
                        special == 'Disabled'
                          ? 'red lighten-2 text--white'
                          : 'grey lighten-2'
                      "
                    >
                      {{ special }}
                    </v-chip>
                  </td>
                </tr>
              </draggable>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
    <a-l-createmodal
      :dialog="addCourseModal"
      @cancel="addCourseModal = false"
      @finish="
        addCourseModal = false;
        onLoad();
      "
    />
    <a-l-editmodal
      :dialog="editModal"
      @cancel="editModal = false"
      :document="editDocument"
      @finish="
        editModal = false;
        onLoad();
      "
    />
  </v-container>
</template>
<style scoped>
.disable-icon:hover {
  color: red !important;
}
.standard-icon:hover {
  color: #2196f3;
}
.longcol {
  min-width: 200px;
  max-width: 250px;
  overflow: hidden;
  white-space: nowrap;
}
.chipcol {
  min-width: 200px;
  white-space: nowrap;
}
.shortcol {
  min-width: 50px;
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
}
.actioncol {
  min-width: 100px;
  overflow: hidden;
  white-space: nowrap;
}
.ghost {
  opacity: 0.5 !important;
  color: white !important;
  background-color: #2196f3 !important;
}
.handle {
  cursor: grab;
}
</style>
<script>
import draggable from "vuedraggable";
import services from "@/services/index.js";
import createNewModal from "./components/createdeliverymodal";
import editModal from "./components/editdeliverymodal";
import shareModal from "./components/sharedeliverymodal";
export default {
  components: {
    draggable,
    "a-l-createmodal": createNewModal,
    // eslint-disable-next-line vue/no-unused-components
    "a-l-editmodal": editModal,
    "a-l-sharemodal": shareModal
  },
  data() {
    return {
      showDisabled: true,
      drag: false,
      deliverys: [],
      addCourseModal: false,
      editModal: false,
      editDocument: null,
      show: ""
    };
  },
  methods: {
    fixNum(num) {
      return Number(num)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    async onLoad() {
      this.$store.commit("setLoading", true);
      this.deliverys = await services.delivery.get({ type: "public" });
      this.deliverys.sort((a, b) => {
        return a.order - b.order;
      });
      console.log("Found", this.deliverys);
      this.$store.commit("setLoading", false);
    },
    isDisabled(delivery) {
      let tags = this.generateTags(delivery);
      return tags.includes("Disabled");
    },
    generateTags(delivery) {
      let cards = [];
      //Limit Copies
      if (delivery.logistics.limitCopies) {
        cards.push("Limit Users");
      }
      if (delivery.properties.allowAnonymousUsers) {
        cards.push("Account Not Required");
      }
      //Hidden
      if (delivery.properties.hidden) {
        cards.push("Hidden");
      }
      //Access Code
      if (delivery.properties.requireAccessCode) {
        cards.push("Access Code");
      }
      if (
        delivery.properties.skipDays &&
        delivery.properties.skipDays.length > 0
      ) {
        cards.push("Skipped Days");
      }
      //Disabled
      if (delivery.properties.disabled) {
        cards.push("Disabled");
      }
      return cards;
    },
    async edit(item) {
      console.log(JSON.parse(JSON.stringify(item)));
      this.editModal = true;
      this.editDocument = JSON.parse(JSON.stringify(item));
    },
    async disable(item) {
      this.$store.commit("setLoading", true);

      console.log("disable", item);
      item.properties.disabled = !item.properties.disabled;
      await services.delivery.update({
        id: item._id,
        document: item,
        type: "public"
      });
      this.$store.commit("setLoading", false);

      this.onLoad();
    },
    async share(item) {
      console.log("share");
      this.show = item._id;
      console.log(this.show);
    },
    async updateList(xxx) {
      console.log("Updating", xxx);
      let updates = [];
      this.deliverys.forEach((obj, index) => {
        if (obj.order != index) {
          updates.push({
            _id: obj._id,
            order: index,
            before: obj.order,
            full: obj
          });
        }
      });
      if (updates.length === 0) {
        return;
      }
      updates.forEach(update => {
        services.delivery.update({
          id: update._id,
          document: { order: update.order },
          type: "public"
        });
      });
    },
    filterDeliveries(deliveries) {
      return deliveries.filter(obj => {
        const disabled =
          obj && obj.properties ? obj.properties.disabled : false;
        if (!this.showDisabled) {
          return !disabled;
        } else {
          return true;
        }
      });
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>
